<template>
  <Term
    v-if="promotions && promotions.length"
    :small="small"
    :term="setTerm()"
  />
</template>
<script>
import { mapState } from "vuex";
import { buildTermString } from "@/util.js";
import Term from "@/components/Product/Promotions/Terms/Term.vue";

export default {
  name: "TermsSingle",
  components: { Term },
  computed: {
    ...mapState({
      priceIncreaseEnabled: (state) => state.store.info.price_increase.enabled,
    }),
  },
  methods: {
    setTerm() {
      return this.promotions.length !== 1
        ? { limit: null, offer: "Multiple Deals" }
        : buildTermString(
            this.byweight,
            this.promotions[0],
            this.priceIncreaseEnabled,
            true,
          );
    },
  },
  props: { byweight: Boolean, promotions: Array, small: Boolean },
};
</script>
